var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54792 1.51079C7.80345 1.2744 8.19784 1.2744 8.45336 1.51079L11.7418 4.55291C12.012 4.80294 12.0285 5.22473 11.7784 5.495C11.5284 5.76528 11.1066 5.78169 10.8363 5.53166L8.66731 3.52509L8.66731 9.96183C8.66731 10.33 8.36883 10.6285 8.00064 10.6285C7.63245 10.6285 7.33398 10.33 7.33398 9.96183L7.33398 3.52509L5.16496 5.53166C4.89468 5.78169 4.47289 5.76528 4.22286 5.495C3.97283 5.22473 3.98924 4.80294 4.25951 4.55291L7.54792 1.51079ZM2.66667 11.9777C3.03486 11.9777 3.33333 12.2762 3.33333 12.6444V13.2529C3.44026 13.3051 3.56008 13.3335 3.68397 13.3335H12.316C12.4399 13.3335 12.5597 13.3051 12.6667 13.2529V12.6444C12.6667 12.2762 12.9651 11.9777 13.3333 11.9777C13.7015 11.9777 14 12.2762 14 12.6444V13.5886C14 13.7682 13.9276 13.9402 13.7991 14.0656C13.4031 14.4523 12.8694 14.6668 12.316 14.6668H3.68397C3.13062 14.6668 2.59685 14.4523 2.20088 14.0656C2.07242 13.9402 2 13.7682 2 13.5886V12.6444C2 12.2762 2.29848 11.9777 2.66667 11.9777Z",
    fill: "#003193"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUpload);
export default __webpack_public_path__ + "static/media/ic-upload.df64453ceaeff546ebde0fa72859977a.svg";
export { ForwardRef as ReactComponent };